import { ISize } from 'shared/types/Size';
import { IBuyBarProductSizeOption, IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';

// #TODO: Improve this logic. Want more readable, and more convenient;
// `availableSizes` will sometimes include sizes that don't exist typically due to
// seller or admin input error when creating the product. `sizeOptions` from the PT includes
// a valid array of sizes where we can validate and pass only the sizes that are in `sizeOptions`
export const getAllSizes = (sizeOptions: ISize[], availableSizes: IBuyBarProductVariant[]) => {
  return sizeOptions.map((sizeOption) => {
    for (const availableSize of availableSizes) {
      if (sizeOption.value === availableSize.sizeOption.value) {
        return availableSize;
      }
    }
    return { sizeOption } as IBuyBarProductSizeOption;
  });
};
